import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Footer component - Bottom section of the application
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="md:flex md:justify-between">
          {/* Logo and description */}
          <div className="mb-6 md:mb-0 md:w-1/3">
            <Link to="/" className="flex items-center">
              <span className="self-center text-2xl font-bold whitespace-nowrap">Biotech01</span>
            </Link>
            <p className="mt-2 text-gray-400 text-sm max-w-md">
              Connecting the biotech and health tech ecosystem - where startups, investors, and service providers collaborate to accelerate innovation.
            </p>
          </div>
          
          {/* Quick links */}
          <div className="grid grid-cols-2 gap-8 md:gap-6 md:w-2/3 md:grid-cols-3">
            <div>
              <h2 className="mb-4 text-sm font-semibold uppercase">Platform</h2>
              <ul className="text-gray-400">
                <li className="mb-2">
                  <Link to="/" className="hover:underline">Home</Link>
                </li>
                <li className="mb-2">
                  <Link to="/gallery" className="hover:underline">Gallery</Link>
                </li>
                <li className="mb-2">
                  <Link to="/resources" className="hover:underline">Resources</Link>
                </li>
                <li>
                  <Link to="/about" className="hover:underline">About Us</Link>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="mb-4 text-sm font-semibold uppercase">Legal</h2>
              <ul className="text-gray-400">
                <li className="mb-2">
                  <Link to="/privacy-policy" className="hover:underline">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-of-service" className="hover:underline">Terms of Service</Link>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="mb-4 text-sm font-semibold uppercase">Contact</h2>
              <ul className="text-gray-400">
                <li className="mb-2">
                  <Link to="/contact" className="hover:underline">Contact Us</Link>
                </li>
                <li className="mb-2">
                  <a href="mailto:support@biotech01.com" className="hover:underline">Email Support</a>
                </li>
                <li>
                  <a href="https://linkedin.com/company/biotech01" target="_blank" rel="noopener noreferrer" className="hover:underline">LinkedIn</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <hr className="my-6 border-gray-700 sm:mx-auto lg:my-8" />
        <div className="text-center">
          <span className="text-sm text-gray-400">
            © {currentYear} Biotech01. All Rights Reserved.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 